import { CSSProperties } from 'react';
import { DEFAULT_MAX_WIDTH } from '../constants';

export const getWidthStyle = (
  width?: number,
  width_max?: '100%',
  is_scroll_horizontal_overflow?: boolean,
): Pick<CSSProperties, 'width' | 'maxWidth'> => {
  let elWidth = width_max === '100%' ? width_max : `${width || DEFAULT_MAX_WIDTH}px`;
  if (width_max === '100%' && is_scroll_horizontal_overflow) {
    elWidth = `${DEFAULT_MAX_WIDTH}px`;
  }
  return {
    width: elWidth,
    maxWidth:
        width_max === '100%'
          ? width_max
          : `min(100%, ${Math.max(DEFAULT_MAX_WIDTH, width || 0)}px)`,
  };
};
